/* eslint-disable */

import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { MainLayout } from 'views/layouts'
import { Container, Content, SelectorsContainer, FooterContent, HeaderContainer } from './styled'
import Stepper from 'views/components/Stepper'
import { H2, P } from 'views/components/UI/Text'
import InputRadio from 'views/components/UI/InputRadio'
import { Button, BackButton } from 'views/components/UI/Buttons'
import ModalLoader from 'views/components/UI/ModalLoader/modal-loader'
import ModalConfirmDeleteEditedRoleFamily from './modal-confirm-delete-edited-rolefamily'
import { platformAdminRoutes } from 'router/routes'
import InfoRoleFamilyContainer from 'views/containers/RoleFamily/infoRoleFamily'
import AlertComponent from 'views/components/Alert'
import {
  stepOneSelector,
  stepTwoSelector,
  setStepTwoTrigger,
  setStepThree,
  setStepFour,
  setLoading as setLoadingProcess,
  stepFourSelector,
  stepFiveSelector,
  setUserListAdded,
  cleanStepsFromThree,
} from 'ducks/createProcess'
import { RoleFamily as IRoleFamily, Level as ILevel } from 'types/common'
import { STEPS_NEW_PROCESS } from '../constants'
import { generalDataSelector } from 'ducks/auth'
import getRoleFamilyByFilters from 'services/rolFamily/fetchGetRoleFamilyByLevel'
import { parseQuadrantFullNameToShortName } from 'utils/common'
import { User } from '../Users/constants'
import useDeleteUsersInProcess from 'hooks/process/useDeleteUsersInProcess/use-delete-users-in-process'
import { deleteModelProcessAssociation } from 'views/screens/super-admin/homologation-skills/services/deleteModelProcessAssociation'
import { useGetCreditsAvailables } from 'hooks/inventory/useInventory'
import { useTranslation } from 'react-i18next'
import { useNotification } from 'lib/context/notification.context'
import { updateProcess } from 'services/common/process/createProcess/create-process-service'

function RoleFamily() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { data: generalData } = useSelector(generalDataSelector)
  const stepOneData = useSelector(stepOneSelector)
  const stepTwoData = useSelector(stepTwoSelector)
  const stepFourData = useSelector(stepFourSelector)
  const stepFiveData = useSelector(stepFiveSelector)
  const isRoleFamilySelected = stepTwoData?.isRoleFamilySelected
  const levelOptions = generalData?.level
  const hasEditedRoleFamily = stepFourData?.isEditingRoleFamily
  const { getWarning } = useNotification()

  const { deleteUsersInProcess, deleteTestsInProcess } = useDeleteUsersInProcess()

  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [showModalConfirmDeleteEditedRoleFamily, setShowModalConfirmDeleteEditedRoleFamily] = useState<boolean>(false)

  const [nameRoleFamilySelected, setNameRoleFamilySelected] = useState<string>(stepTwoData?.roleFamilyName || '')
  const [editingRoleFamily, setEditingRoleFamily] = useState(false)
  const [isSelectedRoleFamily, setIsSelectedRoleFamily] = useState<boolean | null>(isRoleFamilySelected || null)
  const [roleFamilies, setRoleFamilies] = useState<IRoleFamily[]>([])
  const [roleFamily, setRoleFamily] = useState<any>()

  const { refreshCredits } = useGetCreditsAvailables(stepOneData.inventoryTypeId)

  useEffect(() => {
    if (stepFiveData?.userListAdded) {
      dispatch(setUserListAdded([]))
      const idUsersToDelete = stepFiveData?.userListAdded
        .map((user: User) => user.id)
        .filter((id: number) => id !== undefined)

      if (idUsersToDelete.length > 0) {
        deleteUsersInProcess(stepOneData.processId, idUsersToDelete)
      }
      refreshCredits()
    }
  }, [])

  useEffect(() => {
    const levelSelected = levelOptions?.find((level: ILevel) => level.id === stepOneData.level)?.name || ''
    getRoleFamilyByFilters({ level: levelSelected }).then((res) => {
      if (res.status === 'OK') {
        setRoleFamilies(res.roleFamilies)
      }
    })
  }, [stepTwoData, stepOneData, generalData, levelOptions])

  useEffect(() => {
    if (!isRoleFamilySelected) {
      setNameRoleFamilySelected('')
      setIsSelectedRoleFamily(null)
    }
  }, [isRoleFamilySelected])

  const handleCreateProcessFromScratch = async () => {
    // Limpiar estados de pasos posteriores antes de crear proceso desde cero
    dispatch(cleanStepsFromThree())

    // Eliminar tests y modelo de proceso existentes antes de continuar
    try {
      await deleteTestsInProcess(stepOneData.processId)
      await deleteModelProcessAssociation(stepOneData.processId)
    } catch (error) {
      console.error('Error al limpiar tests y modelo:', error)
    }

    dispatch(setStepTwoTrigger.run({ isRoleFamilySelected: false, processId: stepOneData.processId }))
    navigate(platformAdminRoutes.SelectTestsType)
  }

  const handleCreateProcessWithRoleFamily = async () => {
    const profileValueEdited = stepFourData.betesaIdealProfile?.profileValues
      ? stepFourData.betesaIdealProfile?.profileValues.map((item: any) => {
          return {
            quadrant: parseQuadrantFullNameToShortName(item.quadrant),
            priority: item.priority,
            min: item.min,
            max: item.max,
          }
        })
      : roleFamily?.ideal_profile?.map((item: any) => {
          return {
            quadrant: parseQuadrantFullNameToShortName(item.quadrant),
            priority: item.priority,
            min: item.min,
            max: item.max,
          }
        })

    const competencesIdealProfile = stepFourData.competencesIdealProfile
      ? stepFourData.competencesIdealProfile?.map((item: any) => {
          const formattedItem: any = {
            skill_id: item.skill_id || item.id,
          }

          if (Number(item.weight) > 0) {
            formattedItem.weight = Number(item.weight)
          }

          return formattedItem
        })
      : roleFamily?.competence_skills?.map((item: any) => {
          const formattedItem: any = {
            skill_id: item.skill_id || item.id,
          }

          if (Number(item.weight) > 0) {
            formattedItem.weight = Number(item.weight)
          }

          return formattedItem
        })
    const sanitizedCompetencesIdealProfile = (competencesIdealProfile || []).filter(
      (item: any) => Number(item.skill_id) > 0
    )

    const betesaIdealProfile = {
      alertLevelId: stepFourData?.betesaIdealProfile?.alertLevelId || roleFamily?.ideal_profile[0]?.alert_level_range,
      profileValues: profileValueEdited,
      betesaSkills: [],
    }

    if (loading) {
      return
    }
    setLoading(true)

    try {
      dispatch(
        setStepTwoTrigger.run({
          isRoleFamilySelected: true,
          processId: stepOneData.processId,
          roleFamilyName: nameRoleFamilySelected,
        })
      )

      await deleteTestsInProcess(stepOneData.processId)
      await deleteModelProcessAssociation(stepOneData.processId)

      const dataUpdateStepThree = {
        processId: stepOneData.processId,
        onlineCourse: false,
        useBetesaTest: roleFamily.ideal_profile.length > 0,
        useSkillsTest: roleFamily.competence_skills.length > 0,
      }

      const stepThreeResponse = await updateProcess(stepOneData.processId, {
        test_selection: {
          online_course: dataUpdateStepThree.onlineCourse,
          betesa_test: dataUpdateStepThree.useBetesaTest,
          competences_test: dataUpdateStepThree.useSkillsTest,
          test_360: false,
        },
      })

      if (stepThreeResponse.status === 'error') {
        const stepThreeMessage =
          (stepThreeResponse as any).message || stepThreeResponse.error || 'No fue posible crear las pruebas para el proceso'
        getWarning(String(stepThreeMessage))
        return
      }

      dispatch(setStepThree(dataUpdateStepThree as any))

      const dataUpdateStepFourStore: any = {
        processId: stepOneData.processId,
        isEditingRoleFamily: Object.keys(stepFourData).length > 0,
      }

      const dataUpdateStepFourApi: any = {}

      if (betesaIdealProfile.alertLevelId?.length > 0) {
        const normalizedAlertRange = [...betesaIdealProfile.alertLevelId]
          .map((item: any) => Number(item))
          .filter((item: number) => !Number.isNaN(item))
          .sort((a: number, b: number) => a - b)
        if (normalizedAlertRange.length === 0) {
          getWarning('No fue posible determinar el rango de alerta para BETESA')
          return
        }

        dataUpdateStepFourStore.betesaIdealProfile = betesaIdealProfile
        dataUpdateStepFourApi.betesa_ideal_profile = {
          alert_level_range: [
            normalizedAlertRange[0],
            normalizedAlertRange[normalizedAlertRange.length - 1],
          ],
          profile_values: profileValueEdited,
          betesa_skills: [],
        }
      }

      if (sanitizedCompetencesIdealProfile.length > 0) {
        dataUpdateStepFourStore.competencesIdealProfile = sanitizedCompetencesIdealProfile
        dataUpdateStepFourApi.competences_ideal_profile = sanitizedCompetencesIdealProfile
      }

      let stepFourResponse: any = { status: 'OK' }

      if (Object.keys(dataUpdateStepFourApi).length > 0) {
        stepFourResponse = await updateProcess(stepOneData.processId, {
          ideal_profile: dataUpdateStepFourApi,
        })
      }

      if (stepFourResponse.status === 'error') {
        const stepFourMessage =
          (stepFourResponse as any).message || stepFourResponse.error || 'No fue posible guardar el perfil ideal'
        getWarning(String(stepFourMessage))
        return
      }

      dispatch(setStepFour(dataUpdateStepFourStore))
      navigate(platformAdminRoutes.CreateUsers)
    } catch (error: any) {
      const backendMessage = error?.response?.data?.message
      getWarning(backendMessage || error?.message || 'Ocurrio un error al guardar la familia de rol')
    } finally {
      setLoading(false)
    }
  }

  return (
    <MainLayout>
      <Container>
        <HeaderContainer>
          <H2 margin="10px 0px 40px 20px">Familia de rol</H2>
          <Stepper activeStep={editingRoleFamily ? 3 : 1} steps={STEPS_NEW_PROCESS} />
        </HeaderContainer>
        <Content>
          <SelectorsContainer>
            <P marginRight="16px">Voy a usar</P>
            <InputRadio
              label="Familia de rol"
              value="Familia de rol"
              checked={isSelectedRoleFamily === true}
              onChange={() => {
                setIsSelectedRoleFamily(true)
                // Limpiar estados de pasos posteriores al cambiar a familia de rol
                dispatch(cleanStepsFromThree())
              }}
            />
            <InputRadio
              label="Configuración desde cero"
              value="Configuración desde cero"
              checked={isSelectedRoleFamily === false}
              onChange={() => {
                setIsSelectedRoleFamily(false)
                // Limpiar estados de pasos posteriores al cambiar a desde cero
                dispatch(cleanStepsFromThree())
              }}
            />
          </SelectorsContainer>
          {isSelectedRoleFamily && (
            <InfoRoleFamilyContainer
              onEditRoleFamily={(e) => {
                setRoleFamily(e)
              }}
              defaultRole={nameRoleFamilySelected}
              onSelectRole={(e: string) => {
                // Si se selecciona una familia de rol diferente, limpiar estados posteriores
                if (e !== nameRoleFamilySelected) {
                  dispatch(cleanStepsFromThree())
                }
                setNameRoleFamilySelected(e)
              }}
              options={roleFamilies}
              onChangeEditingRoleFamily={(e: boolean) => setEditingRoleFamily(e)}
            />
          )}
          {!isSelectedRoleFamily && <></>}
        </Content>
        {editingRoleFamily !== true && !isSelectedRoleFamily && (
          <FooterContent>
            <BackButton onClick={() => navigate(platformAdminRoutes.CreateProcess)} />
            <Button
              disabled={
                (isRoleFamilySelected === true || isSelectedRoleFamily === null) && isSelectedRoleFamily !== false
              }
              onClick={() => (!isSelectedRoleFamily ? handleCreateProcessFromScratch() : null)}
              style={{
                padding: '10px 20px',
              }}
              type="button"
            >
              {isSelectedRoleFamily ? t('global.common.nextButtonText') : 'Selección de pruebas'}
            </Button>
          </FooterContent>
        )}
        {isSelectedRoleFamily && !editingRoleFamily && (
          <FooterContent>
            <BackButton
              onClick={() => {
                if (hasEditedRoleFamily || (stepTwoData.roleFamilyName && stepFourData.processId)) {
                  setShowModalConfirmDeleteEditedRoleFamily(true)
                } else {
                  navigate(platformAdminRoutes.CreateProcess, { replace: true })
                }
              }}
            />
            <Button
              disabled={!nameRoleFamilySelected}
              type="submit"
              onClick={handleCreateProcessWithRoleFamily}
              onDisabledClick={() => {
                setShowAlert(true)
                setTimeout(() => {
                  setShowAlert(false)
                }, 3000)
              }}
            >
              {t('global.common.nextButtonText')}
            </Button>
          </FooterContent>
        )}
      </Container>
      {showModalConfirmDeleteEditedRoleFamily && (
        <ModalConfirmDeleteEditedRoleFamily
          visible={showModalConfirmDeleteEditedRoleFamily}
          onAccept={() => {
            // Limpiar estados al volver atrás después de editar familia de rol
            dispatch(cleanStepsFromThree())
            dispatch(setLoadingProcess(false))
            navigate(platformAdminRoutes.CreateProcess, { replace: true })
          }}
          onCancel={() => setShowModalConfirmDeleteEditedRoleFamily(false)}
        />
      )}
      <ModalLoader isLoading={loading} />
      <AlertComponent message="Primero debes seleccionar una familia de rol" severity="warning" open={showAlert} />
    </MainLayout>
  )
}

export default RoleFamily
